export default "assets/images/49609c69f4fde6f07c34a2bbc8ad7e53.png";